import React from 'react';
import SliderMobile from 'components/SliderMobile';
import { IProps } from './types';
import _ from 'lodash';
import { EventProdList } from 'bff/models/promotion';
import { withRouter } from 'react-router-dom';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { RouterSettings } from 'constants/models/routerSettings';
import commonService from 'utils/commonService';
import { AddFavoriteItem } from 'bff/models/member';
import { PlanType } from 'constants/enums/travelPlanType.enum';

const InnerPageBSchemes: React.FC<IProps> = (props) => {
  const handleRedirect = (product: EventProdList) => {
    const path = {
      pathname: product.APPLY_URL,
      state: {
        insTypeId: product.INS_TYPE_ID,
        prodId: product.PROD_ID
      }
    };
    commonService.setActiveProdId(product.INS_TYPE_ID, product.PROD_ID);
    props.history.push(path);
  };

  /**
   * @description 收藏按鈕(愛心)狀態切換
   */
  const handleFavoriteStatusToggle = (insTypeId: string, planId: string, prodId: string, isActive?:boolean) => {
    const isLogin = storageService.getItem(storageKeys.LoginInfo);

    if (!isLogin) {
      sweetAlertService.modal({
        html: 'Hi~請問是否登入會員，以確保下次登入時還能看到收藏的內容唷！',
        showCancelButton: true,
        showCloseButton: true
      }).then((response) => {
        if (response.value) {
          props.unloginAddItem && props.unloginAddItem(insTypeId, prodId, planId);

          props.history.push(RouterSettings.Login);
        }
      });

      return;
    }

    if (isActive) {
      sweetAlertService.modal({
        html: 'Hi~您確定要取消收藏嗎？',
        showCancelButton: true,
        showCloseButton: true
      }).then((response) => {
        if (response.value) {
          // 移除用的 SN 或 planId
          const removeId = commonService.getFavoriteItemSN(props.myFavoriteList || [], insTypeId, prodId, planId);
          props.onRemoveFavoriteItem && props.onRemoveFavoriteItem(removeId);
        }
      });
    } else {
    // 新增我的收藏用 Model
      const addFavoriteItem: AddFavoriteItem = commonService.getAddFavoriteItem(insTypeId, prodId, planId);
      props.onAddFavoriteItem && props.onAddFavoriteItem(addFavoriteItem);
    }
  };

  return (
    <div className="schemes__inner-page-b-schemes">
      <div className="template-container">
        <div className="template-content">
          <div className="schemes-list">
            <div className="schemes-list__col">
              <span>您想要投保</span>
            </div>
            {
              _.map(props.EVENT_PROD_LIST, (itemContent: EventProdList, index: number) => {
                const isActive = commonService.matchFavorite(props.myFavoriteList, itemContent.INS_TYPE_ID, itemContent.PROD_ID, itemContent.PLAN_ID);
                const className = ['schemes-list__favorite-btn'];
                if (isActive) className.push('schemes-list__favorite-btn--active');

                if (itemContent.PLAN_ID === PlanType.Free) className.push('visibility-hidden');

                return (
                  <div className="schemes-list__col" key={index}>
                    <button
                      type="button"
                      className={className.join(' ')}
                      onClick={() => handleFavoriteStatusToggle(itemContent.INS_TYPE_ID, itemContent.PLAN_ID, itemContent.PROD_ID, isActive)}
                    />
                    <div className="schemes-list__scheme">
                      <span>{itemContent.TITLE}</span>
                      <span>試算保費</span>
                      <span>{itemContent.EST_FEE}</span>
                      <button type="button" onClick={() => handleRedirect(itemContent)} className="schemes-list__btn">我要保這個</button>
                    </div>
                  </div>
                );
              })
            }
            {/* <div className="schemes-list__col">
            <button type="button" className="schemes-list__favorite-btn" />
            <div className="schemes-list__scheme">
              <span>海外A型-基本型</span>
              <span>試算保費</span>
              <span>NT$ 94元</span>
              <button type="button" className="schemes-list__btn">我要保這個</button>
            </div>
          </div>
          <div className="schemes-list__col">
            <button type="button" className="schemes-list__favorite-btn" />
            <div className="schemes-list__scheme">
              <span>海外B型-加值型</span>
              <span>試算保費</span>
              <span>NT$ 206元</span>
              <button type="button" className="schemes-list__btn">我要保這個</button>
            </div>
          </div>
          <div className="schemes-list__col">
            <button type="button" className="schemes-list__favorite-btn" />
            <div className="schemes-list__scheme">
              <span>海外B型-保障型</span>
              <span>試算保費</span>
              <span>NT$ 270元</span>
              <button type="button" className="schemes-list__btn">我要保這個</button>
            </div>
          </div> */}
          </div>
          <div className="schemes-list-mobile">
            <SliderMobile name="schemes-list-mobile-slider">
              {
                _.map(props.EVENT_PROD_LIST, (itemContent: EventProdList, index: number) => {
                  const isActive = commonService.matchFavorite(props.myFavoriteList, itemContent.INS_TYPE_ID, itemContent.PROD_ID, itemContent.PLAN_ID);
                  const className = ['schemes-list-mobile__favorite-btn'];

                  if (isActive) className.push('schemes-list-mobile__favorite-btn--active');

                  if (itemContent.PLAN_ID === PlanType.Free) className.push('visibility-hidden');
                  return (
                    <SliderMobile.Item key={index}>
                      <div className="schemes-list-mobile__item">
                        <div className="schemes-list-mobile__item-container">
                          <span>{itemContent.TITLE}</span>
                          <span>試算保費</span>
                          <span>{itemContent.EST_FEE}</span>
                          <button type="button" onClick={() => handleRedirect(itemContent)} className="schemes-list-mobile__btn">我要保這個</button>
                          <button type="button" className={className.join(' ')} onClick={() => handleFavoriteStatusToggle(itemContent.INS_TYPE_ID, itemContent.PLAN_ID, itemContent.PROD_ID, isActive)} />
                        </div>
                      </div>
                    </SliderMobile.Item>
                  );
                })
              }
              {/* <SliderMobile.Item>
              <div className="schemes-list-mobile__item">
                <div className="schemes-list-mobile__item-container">
                  <span>旅行平安險</span>
                  <span>海外A型-基本型</span>
                  <span>試算保費</span>
                  <span>NT$ 94元</span>
                  <button type="button" className="schemes-list-mobile__btn">我要保這個</button>
                  <button type="button" className="schemes-list-mobile__favorite-btn" />
                </div>
              </div>
            </SliderMobile.Item>
            <SliderMobile.Item>
              <div className="schemes-list-mobile__item">
                <div className="schemes-list-mobile__item-container">
                  <span>旅行平安險</span>
                  <span>海外A型-基本型</span>
                  <span>試算保費</span>
                  <span>NT$ 94元</span>
                  <button type="button" className="schemes-list-mobile__btn">我要保這個</button>
                  <button type="button" className="schemes-list-mobile__favorite-btn" />
                </div>
              </div>
            </SliderMobile.Item>
            <SliderMobile.Item>
              <div className="schemes-list-mobile__item">
                <div className="schemes-list-mobile__item-container">
                  <span>旅行平安險</span>
                  <span>海外A型-基本型</span>
                  <span>試算保費</span>
                  <span>NT$ 94元</span>
                  <button type="button" className="schemes-list-mobile__btn">我要保這個</button>
                  <button type="button" className="schemes-list-mobile__favorite-btn" />
                </div>
              </div>
            </SliderMobile.Item> */}
            </SliderMobile>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(InnerPageBSchemes);
